export default function productCategoryMapper({ isPlan }) {
  if (isPlan) {
    return 'plan';
  }
  return 'standalone';
}
